module.exports = __webpack_public_path__ + "assets/img/fd9ffef39a9856a4f9b0125c139ed40b.svg";